<div class=" pl-0 pt-3" style="margin-left: 2%;margin-right: 2%;">
  <div class="row  pt-2" style="display: flex; align-items: center; margin-bottom: 3%;">
    <div class="col-md-2 w-100">
      <p class="m-0 text-uppercase" style="font-size: 20px;color: #262756;font-weight: bold;">alarmes</p>
      <small class="text-uppercase" style="font-size:15px;color: #959090;">Historique des alarmes </small>
    </div>
    <div class="col-lg- col-xl-3 col-md-6 w-100 pl-md-0">
      <mat-form-field appearance="fill">
        <mat-label>Filtrer par date Début-Fin</mat-label>
        <input autocomplete="off" readonly (ngModelChange)="getFilter()" matInput #input id="dateTime"
               [(ngModel)]="dateTime" [selectMode]="'range'" [owlDateTime]="dt10" [owlDateTimeTrigger]="dt10"/>

        <button mat-button matSuffix mat-icon-button [owlDateTimeTrigger]="dt10">
          <mat-icon placement="left" ngbTooltip="Choisir date début-fin">date_range</mat-icon>
        </button>
        <button (click)="getdd()" mat-button matSuffix mat-icon-button>
          <mat-icon placement="top" ngbTooltip="Appliquer le filtrage">done_all</mat-icon>
        </button>
        <button placement="bottom"
                ngbTooltip="réinitialiser"
                (click)="resetDate()" mat-button matSuffix mat-icon-button>
          <mat-icon (click)="resetDate()">format_color_reset</mat-icon>
        </button>
        <owl-date-time [pickerType]="'calendar'" #dt10></owl-date-time>
      </mat-form-field>
    </div>
  </div>
  <div class="row pt-2 w-100 mx-0">
    <div class="col-2">
      <div class="export-icons d-flex mb-2">
        <div class="icn-sec">
          <img (click)="exportExcel(exportDirective, 'xlsx')" src="assets/newImages/excel-svg.svg"
               ngbTooltip="Expoter EXCEL"/>
        </div>
        <div class="icn-sec">
          <img (click)="exportTable()" src="assets/newImages/pdf-svg.svg" ngbTooltip="Expoter PDF"/>
        </div>
      </div>
    </div>
    <div class="col-lg-1 col-xl-1 col-md-6 pl-0">
      <!--            <mat-form-field appearance="fill" >-->
      <!--                <mat-label>Page</mat-label>-->
      <!--                <mat-select>-->
      <!--                    <mat-option *ngFor="let item of collection" (click)="updateManualPage(item - 1)" [value]="item">-->
      <!--                        {{ item }}-->
      <!--                    </mat-option>-->
      <!--                </mat-select>-->
      <!--            </mat-form-field>-->
    </div>
    <div class="col-lg-1 col-xl-1 col-md-6 pl-0 pr-md-0 mb-md-2">
      <!--            <mat-form-field appearance="fill">-->
      <!--                <mat-label>Eléments</mat-label>-->
      <!---->
      <!--                <mat-select [(ngModel)]="pageSize">-->
      <!--                    <mat-option (click)="updateManualPage2(pageSize)" *ngFor="let pageSize of pageSizeOptions"-->
      <!--                        [value]="pageSize">-->
      <!--                        {{ pageSize }}</mat-option>-->
      <!--                </mat-select>-->
      <!--            </mat-form-field>-->
    </div>
    <div class="col-5 w-100">

    </div>
    <div class="col-lg-3 col-xl-3 col-md-6 w-100" style="text-align: end;">
      <div class="col-12 pl-0">
        <mat-form-field appearance="fill">
          <mat-label>Filtrer par nom de véhicule</mat-label>
          <input autocomplete="off" type="text" aria-label="Number" matInput
                 [formControl]="searchControl" #input id="getdt" name="getdt" value="{{ itemSelect2 }}"/>

<!--          <button mat-button matSuffix mat-icon-button>-->
<!--            <mat-icon placement="left" ngbTooltip="Actualiser les données des vehicules"-->
<!--                      (click)="getUserrefrech()">update-->
<!--            </mat-icon>-->
<!--          </button>-->
          <button mat-button matSuffix mat-icon-button>
            <mat-icon (click)="resetFilter()" placement="left" ngbTooltip="Réinitialiser les filtres">
              format_color_reset
            </mat-icon>
          </button>
        </mat-form-field>
      </div>
    </div>
  </div>
  <hr style="border: 1px solid #e8e4e4;margin-top: 3%;">
  <div class="row rowposition pt-3 ">
    <div class="col-12 col-md-12 w-100 tableSpinner">
      <div class=" example-container mat-elevation-z8 ">
        <ngx-spinner *ngIf="alarmHistory ==true" bdColor="rgba(100,112,124,0.56)" size="medium" color="#233547"
                     type="ball-clip-rotate-multiple" [fullScreen]="false">
          <p style="color: white"></p>
        </ngx-spinner>

        <table id="ExampleTable" class="table-hover" #exportDirective="matTableExporter" matTableExporter
               mat-table [dataSource]="dataSource" matSort>
          <!-- ID Column -->
          <ng-container matColumnDef="unit_id">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              ID. Véhicule
            </th>
            <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row?.id }"
                (click)="getItemDetails(row)">
              {{ row?.unit_id}}
            </td>
          </ng-container>
          <ng-container matColumnDef="unit">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              Véhicule
            </th>
            <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row?.id }"
                (click)="getItemDetails(row)">
              {{ row?.unit }}
            </td>
          </ng-container>

          <ng-container matColumnDef="date">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              Date de l'alarme
            </th>
            <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row?.id }"
                (click)="getItemDetails(row)">
              {{ row?.date }}
            </td>
          </ng-container>
          <ng-container matColumnDef="type">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              Type
            </th>
            <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row?.id }"
                (click)="getItemDetails(row)">
              <div placement="left" ngbTooltip="Accident">
                <img *ngIf="(row?.type == 2 )" src="assets/icons/transit-car-accident.svg"
                     style="width: 26; height: 26;" alt=""/>
              </div>
              <div placement="left" ngbTooltip="Evénement brusque">
                <svg *ngIf="(row?.type == 1 )" width="26" height="26" viewBox="0 0 464 464"
                     xmlns="http://www.w3.org/2000/svg" fill="#262756">
                  <path
                    d="m353.511719 232h-72.328125c7.464844 10.902344 12.191406 23.351562 13.960937 36.511719 7.757813-2.863281 16.113281-4.511719 24.855469-4.511719h39.59375c-.691406-11.105469-2.730469-21.832031-6.082031-32zm0 0"/>
                  <path
                    d="m104.40625 264h39.59375c8.742188 0 17.097656 1.648438 24.855469 4.511719 1.769531-13.160157 6.496093-25.609375 13.960937-36.511719h-72.328125c-3.351562 10.167969-5.390625 20.894531-6.082031 32zm0 0"/>
                  <path
                    d="m424.28125 248.121094 14.597656 58.414062c.984375 3.945313.714844 8.03125-.800781 11.816406l-11.820313 29.542969c-2.9375 7.351563-9.960937 12.105469-17.882812 12.105469-8.566406 0-15.984375-5.511719-18.445312-13.726562l-17.671876-58.898438c-1.320312-4.414062-5.304687-7.375-9.914062-7.375-5.703125 0-10.34375 4.640625-10.34375 10.351562v2.671876c0 1.121093.175781 2.214843.527344 3.273437l31.472656 94.40625v41.296875h65.753906l14.148438-56.59375.097656-70.023438-15.183594-61.144531c-.113281-.429687-.3125-.839843-.585937-1.183593l-45.191407-58.109376c9.066407 17.734376 15.496094 37.039063 18.664063 57.414063 1.152344 1.777344 2.058594 3.6875 2.578125 5.761719zm0 0"/>
                  <path
                    d="m232 400c5.390625 0 10.726562-.40625 16-1.078125v-62.921875c0-24.832031 12.640625-46.769531 31.816406-59.710938-.878906-16.664062-7.59375-32.21875-19.222656-44.289062h-57.1875c-11.636719 12.070312-18.34375 27.625-19.222656 44.289062 19.175781 12.941407 31.816406 34.878907 31.816406 59.710938v62.960938c5.265625.65625 10.59375 1.039062 16 1.039062zm-24-128c0-13.230469 10.769531-24 24-24s24 10.769531 24 24-10.769531 24-24 24-24-10.769531-24-24zm0 0"/>
                  <path
                    d="m240 272c0 4.417969-3.582031 8-8 8s-8-3.582031-8-8 3.582031-8 8-8 8 3.582031 8 8zm0 0"/>
                  <path
                    d="m232 416c-49.785156 0-95.039062-25.214844-121.367188-66.601562l-12.328124 36.976562c33.535156 39.175781 82.054687 61.625 133.695312 61.625 51.695312 0 100.144531-22.441406 133.6875-61.632812l-12.320312-36.960938c-26.222657 40.953125-72.03125 66.59375-121.367188 66.59375zm0 0"/>
                  <path d="m0 448h96v16h-96zm0 0"/>
                  <path d="m368 448h96v16h-96zm0 0"/>
                  <path
                    d="m63.953125 324.320312 12.460937-41.542968c1.960938-6.546875 6.265626-11.777344 11.800782-15.058594 2.289062-77.40625 65.824218-139.71875 143.785156-139.71875s141.496094 62.3125 143.785156 139.71875c5.535156 3.28125 9.839844 8.511719 11.800782 15.058594l12.460937 41.542968c5.25-16.832031 7.953125-34.351562 7.953125-52.320312 0-97.046875-78.953125-176-176-176s-176 78.953125-176 176c0 17.976562 2.703125 35.480469 7.953125 52.320312zm0 0"/>
                  <path
                    d="m80 432v-41.296875l31.472656-94.40625c.351563-1.058594.527344-2.152344.527344-3.273437v-2.671876c0-5.710937-4.640625-10.351562-10.34375-10.351562-4.609375 0-8.59375 2.960938-9.914062 7.375l-17.671876 58.898438c-2.460937 8.214843-9.878906 13.726562-18.445312 13.726562-7.921875 0-14.9375-4.753906-17.882812-12.105469l-11.8125-29.542969c-1.523438-3.792968-1.792969-7.871093-.808594-11.824218l14.597656-58.398438c.519531-2.082031 1.425781-4 2.578125-5.777344 3.175781-20.382812 9.597656-39.6875 18.671875-57.429687l-45.191406 58.117187c-.289063.359376-.488282.777344-.601563 1.226563l-15.0781248 60.328125-.0976562 70.023438 14.257812 57.382812zm0 0"/>
                  <path
                    d="m232 16c19 0 36.871094 7.480469 50.320312 21.054688l11.367188-11.246094c-16.472656-16.640625-38.382812-25.808594-61.6875-25.808594s-45.214844 9.167969-61.679688 25.808594l11.367188 11.246094c13.441406-13.574219 31.3125-21.054688 50.3125-21.054688zm0 0"/>
                  <path
                    d="m271.289062 48.441406c-10.496093-10.609375-24.449218-16.441406-39.289062-16.441406s-28.792969 5.832031-39.289062 16.441406l11.367187 11.246094c7.464844-7.535156 17.386719-11.6875 27.921875-11.6875s20.457031 4.152344 27.921875 11.6875zm0 0"/>
                  <path
                    d="m215.113281 71.0625 11.375 11.25c2.953125-2.984375 8.070313-2.984375 11.023438 0l11.375-11.25c-9.007813-9.109375-24.765625-9.109375-33.773438 0zm0 0"/>
                </svg>
              </div>
            </td>
          </ng-container>
          <!-- Progress Column -->
          <ng-container matColumnDef="temps_ecoule">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              Temps écoulé
            </th>
            <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row?.id }"
                (click)="getItemDetails(row)">
              {{ row?.date | dateAgo }}
            </td>
          </ng-container>
          <!-- Name Column -->
          <ng-container matColumnDef="detail">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              Détails
            </th>
            <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row?.id }"
                (click)="getItemDetails(row)">
              {{ row?.detail }}
            </td>
          </ng-container>
          <!-- Progress Column -->
          <ng-container matColumnDef="score">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              Score de sécurité
            </th>
            <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row?.id }"
                (click)="getItemDetails(row)">
              <circle-progress *ngIf="row?.detail != 'Accident'" [percent]="row?.score" [showSubtitle]=false
                               [radius]="25" [outerStrokeWidth]="2" [innerStrokeWidth]="1"
                               [outerStrokeColor]="updateColor(row?.score)" [innerStrokeColor]="updateColor(row?.score)"
                               [animation]="true" [animationDuration]="700" [titleFontSize]="18"></circle-progress>
              <p *ngIf="row?.detail === 'Accident'">--</p>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row (click)="goToBottom(820)" *matRowDef="let row; columns: displayedColumns"
              (dblclick)="dbClickitem(row?.id , row?.unit_id , row?.trip_id , row?.maneuver_id, row?.search )">
          </tr>
          <!-- Row shown when there is no matching data. -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="20">
              Aucune donnée correspondante à votre recherche

            </td>
          </tr>
          <!-- Row shown when there is no matching data. -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="12">
              Aucune donnée correspondante à votre recherche
            </td>
          </tr>
        </table>
      </div>

      <!--        <mat-paginator #paginator [pageSize]="pageSize" (page)="pageEvent = $event"-->
      <!--                       [pageSizeOptions]="pageSizeOptions" [showFirstLastButtons]="true">-->
      <!--        </mat-paginator>-->
      <mat-paginator [pageSizeOptions]="pageSizeOptions" (page)="pageChanged($event)" showFirstLastButtons>
      </mat-paginator>

    </div>
  </div>
</div>




